module.exports = __webpack_public_path__ + "static/img/z4.ede14417.png";